
const state = {
  currentLandingPageData: null // 当前原生页的数据
}
const mutations = {
  setCurrentLandingPageData(state, payload) {
    state.currentLandingPageData = payload
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
